import { render } from "./ImageView.vue?vue&type=template&id=7c6531a5&scoped=true"
import script from "./ImageView.vue?vue&type=script&lang=js"
export * from "./ImageView.vue?vue&type=script&lang=js"

import "./ImageView.vue?vue&type=style&index=0&id=7c6531a5&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6531a5"]])

export default __exports__